import { GETPublic, isResponseOK } from "../../utils/apis";

export const SET_APP_CONFIGURATION = "SET_APP_CONFIGURATION";

export const setAppConfiguration = (payload) => ({
  type: SET_APP_CONFIGURATION,
  payload,
});

const CONFIG_OK_STATUSES = [200, 201, 204];

const DEFAULT_FOOTER_LINKS = [
  {
    key: "privacy_policy",
    label: "Privacy Policy",
    link: "https://vucaware.com/privacy-policy/",
    description: [
      "Privacy Policy",
      "Terms",
      "Modern Slavery Act",
      "Impression",
    ],
  },
  {
    key: "terms_of_service",
    label: "Terms of Service",
    link: "https://vucaware.com/terms-of-service/",
    description: [
      "Cool stuff",
      "Random feature",
      "Team feature",
      "Developer stuff",
      "Another one",
    ],
  },
  {
    key: "shipping_and_delivery_policy",
    label: "Shipping and Delivery Policy",
    link: "https://vucaware.com/shipping-and-delivery-policy/",
    description: [
      "Privacy Policy",
      "Terms",
      "Modern Slavery Act",
      "Impression",
    ],
  },
  {
    key: "contact_us",
    label: "Contact Us",
    link: "/contact-us",
    description: [],
  },
  {
    key: "widget",
    label: "Widget",
    link: "/widget",
    description: [],
  },
];

/**
 * Fetches app configuration (footerLinks) from API.
 * On API failure or invalid response, uses DEFAULT_FOOTER_LINKS.
 */
export const fetchAppConfiguration = () => async (dispatch, getState) => {
  const state = getState();
  const existing = state?.appConfiguration?.footerLinks;
  if (existing && Array.isArray(existing) && existing.length > 0) {
    return;
  }

  let footerLinks = [];

  try {
    const response = await GETPublic({ endpoint: "/get-app-configuration" });

    if (response && CONFIG_OK_STATUSES.includes(response.status)) {
      const data = response.data;
      if (Array.isArray(data)) {
        footerLinks = data;
      } else if (data && typeof data === "object") {
        const raw =
          data.footerLinks ?? data.data ?? (Array.isArray(data.data) ? data.data : []);
        footerLinks = Array.isArray(raw) ? raw : [];
      }
    }
  } catch (err) {
    // use fallback
  }

  if (!Array.isArray(footerLinks) || footerLinks.length === 0) {
    footerLinks = DEFAULT_FOOTER_LINKS;
  }

  dispatch(
    setAppConfiguration({
      footerLinks,
    })
  );
};
